import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ButtonLoader, FormsUtilsService, MessageService } from '../../../../../core';
import { CurvaAbcVendaFilter } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';
import { CurvaAbcVendaExcelHttpService } from '../services';
import { CurvaAbcVendaExcelExportModal } from './curva-abc-venda-excel-export-modal';

@Component({
    selector: 'sgt-curva-abc-venda-excel-export-modal',
    templateUrl: './curva-abc-venda-excel-export-modal.component.html',
    styleUrls: ['./curva-abc-venda-excel-export-modal.component.less']
})
export class CurvaAbcVendaExcelExportModalComponent implements OnInit {
    elModal: any;
    @ViewChild('form') form: NgForm;
    entityModal: CurvaAbcVendaExcelExportModal;

    constructor(private el: ElementRef,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private curvaAbcVendaExcelHttpService: CurvaAbcVendaExcelHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#nomeExportacao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string) {
        this.entityModal = new CurvaAbcVendaExcelExportModal(perspectiva, filter, orderBy, orderByDir);
        this.elModal.modal({keyboard: false});
    }

    private clear() {
        this.entityModal = null;
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Valida os dados para realizar a exportação */
    private validateExport(): boolean {
        // Nenhum dado
        if (!this.entityModal) {
            this.messageService.info('Não foi possível realizar a exportação por que nenhum dado de exportação foi criado. Tente fechar a janela e abrir novamente.', 'Informação');
            return false;
        }

        // Sem nome da exportação
        if (!this.entityModal.nomeExportacao) {
            this.messageService.info('Informe o nome da exportação para poder exportar', 'Informação');
            jQuery(this.elModal).find('#nomeExportacao').trigger('focus');
            return false;
        }

        // Form inválido
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false;
        }

        return true;
    }

    /** Realiza a exportação da Curva ABC de Vendas para Excel */
    export() {
        if (!this.validateExport()) {
            return false;
        }

        const btn = new ButtonLoader('#btnCurvaAbcVendaExcelExport');
        btn.loading('Exportando');
        this.curvaAbcVendaExcelHttpService.export(this.entityModal.perspectiva, this.entityModal.filter, this.entityModal.orderBy, this.entityModal.orderByDir, this.entityModal.nomeExportacao)
            .then(() => {
                btn.reset();
                this.close();
            })
            .catch(() => {
                this.messageService.error('Ocorreu um erro ao exportar a Curva ABC de Vendas para Excel. Tente novamente', 'Erro ao exportar');
                btn.reset();
            });
    }
}
